import React, { Component } from "react";
import {
  NormalTable,
  InputSearch,
  NormalSelect,
  NormalButtonBackend,
} from "component/common";
import { withTranslation } from "react-i18next";
import { rangelists } from "redux/actions/Backend";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "../style.scss";
export class ItemclassvoucherClass extends Component {
  state = {
    headerDetails: [
      { 
        label: "Code", 
        divClass: "justify-content-end",
        sortKey: "itmCode",
        enabled: true,
        id: "itmCode",
        singleClickFunc: () => this.handleSort("itmCode"),
      },
      { 
        label: "Description",
        sortKey: "itmDesc",
        enabled: true,
        id: "itmDesc",
        singleClickFunc: () => this.handleSort("itmDesc"),
      },
      { 
        label: "Brand",
        sortKey: "brand",
        enabled: true,
        id: "brand",
        singleClickFunc: () => this.handleSort("brand"),
      },
      { 
        label: "Active",
        sortKey: "itmStatus",
        enabled: true,
        id: "itmStatus",
        singleClickFunc: () => this.handleSort("itmStatus"),
      },
    ],
    option: [
      { label: 10, value: 10 },
      { label: 25, value: 25 },
      { label: 50, value: 50 },
      { label: 100, value: 100 },
    ],
    count: 10,
    is_loading: false,
    isoption: false,
    offset: 0,
    data: [],
    perPage: 10,
    current_page: 1,
    List: [],
    seachdata: [],
    pageMeta: {},
    filterdata: {},
    search: "",
    isActive: false,
    isInactive: false,
    isAll: false,
    voucherList: [],
    activeButton:false,
    inactiveButton:false,
    orderBy: "desc",
  };

  componentDidMount = () => {
    this.Listofvoucher({});
  };

  updateState = (data) => {
    if (this.state.isMounted) this.setState(data);
  };

  /* List Sorting */
  handleSort = (sortkey) => {
    let { List, orderBy } = this.state;
    this.setState({
      orderBy: this.state.orderBy == "asc" ? "desc" : "asc",
    });
    if (orderBy === "asc") {
      List.sort((a, b) =>
        a[sortkey] > b[sortkey] ? 1 : b[sortkey] > a[sortkey] ? -1 : 0
      );
    } else {
      List.sort((a, b) =>
        a[sortkey] < b[sortkey] ? 1 : b[sortkey] < a[sortkey] ? -1 : 0
      );
    }
    this.setState({
      List,
    });
  };

  /* List of Voucher Function */
  Listofvoucher = async () => {
    this.setState({
      is_loading: true,
      activeButton: false,
      inactiveButton: false,
    });
    await this.props.rangelists().then((res) => {
      let {
        voucherList,
        pageCount,
        List,
        pageMeta,
        perPage,
        current_page,
      } = this.state;
      voucherList.length = 0;
      for (let key of res) {
        if (key.isvoucher === true) {
          voucherList.push({
            itmCode: key.itmCode,
            itmDesc: key.itmDesc,
            brand: key.brand,
            itmStatus: key.itmStatus,
          });
        }
      }
      List = voucherList.slice(
        (current_page - 1) * perPage,
        (current_page - 1) * perPage + perPage
      );
      pageCount = Math.ceil(voucherList.length / this.state.perPage);
      this.setState({
        voucherList,
        List,
        pageCount,
        is_loading: false,
        isActive: false,
        isInactive: false,
        isAll: true,
        pageMeta: { ...pageMeta, total_pages: pageCount },
      });
    });
  };

  /* List of Active list */
  Listofactivevoucher = async () => {
    this.setState({
      is_loading: true,
      activeButton: true,
      inactiveButton: false,
    });
    await this.props.rangelists().then((res) => {
      let { 
        pageCount, 
        List, 
        isActive, 
        current_page, 
        perPage, 
        pageMeta, 
        count 
      } = this.state;
      let Listone = [];
      for (let key of res) {
        if (key.itmStatus === true) {
          if (key.isvoucher === true) {
            Listone.push({
              itmCode: key.itmCode,
              itmDesc: key.itmDesc,
              brand: key.brand,
              itmStatus: key.itmStatus,
            });
          }
        }
      }
      this.setState({ Listone }, () => {
        pageCount = Math.ceil(Listone.length / this.state.perPage);
        if (!isActive) {
          if (current_page > pageCount) {
            current_page = 1;
          }
          this.setState(
            {
              pageMeta: {
                ...pageMeta,
                current_page,
                total_pages: pageCount,
                per_page: count,
              },
              pageCount,
              List: Listone.slice(
                (current_page - 1) * perPage,
                (current_page - 1) * perPage + perPage
              ),
              is_loading: false,
              isActive: true,
              isInactive: false,
              isAll: false,
            },
            () => {
              
            }
          );
        } else {
          this.setState(
            {
              pageMeta: {
                ...pageMeta,
                total_pages: pageCount,
                per_page: count,
              },
              pageCount,
              List: Listone.slice(
                (current_page - 1) * perPage,
                (current_page - 1) * perPage + perPage
              ),
              is_loading: false,
              isActive: true,
              isInactive: false,
              isAll: false,
            },
            () => {
             
            }
          );
        }
      });
    });
  };

  /* List of Voucher Inactive List */
  Listofinactivevoucher = async () => {
    this.setState({
      is_loading: true,
      activeButton: false,
      inactiveButton: true,
    });
    await this.props.rangelists().then((res) => {
      let {
        pageCount,
        count,
        perPage,
        pageMeta,
        current_page,
        isInactive,
      } = this.state;
      let Listone = [];
      for (let key of res) {
        if (key.itmStatus === false) {
          if (key.isvoucher === true) {
            Listone.push({
              itmCode: key.itmCode,
              itmDesc: key.itmDesc,
              brand: key.brand,
              itmStatus: key.itmStatus,
            });
          }
        }
      }
      this.setState({ Listone }, () => {
        pageCount = Math.ceil(Listone.length / perPage);
        if (!isInactive) {
          if (current_page > pageCount) {
            current_page = 1;
          }
          this.setState(
            {
              pageMeta: {
                ...pageMeta,
                current_page,
                total_pages: pageCount,
                per_page: count,
              },
              pageCount,
              List: Listone.slice(
                (current_page - 1) * perPage,
                (current_page - 1) * perPage + perPage
              ),
              is_loading: false,
              isActive: false,
              isInactive: true,
              isAll: false,
            },
            () => {
              
            }
          );
        } else {
          this.setState(
            {
              pageMeta: {
                ...pageMeta,
                total_pages: pageCount,
                per_page: count,
              },
              pageCount,
              List: Listone.slice(
                (current_page - 1) * perPage,
                (current_page - 1) * perPage + perPage
              ),
              is_loading: false,
              isActive: false,
              isInactive: true,
              isAll: false,
            },
            () => {
              
            }
          );
        }
      });
    });
  };

  /* Select Data Limit */
  temp = ({ target: { value, name } }) => {
    let { count, perPage, pageMeta, isInactive, isActive } = this.state;
    if (name == "count") {
      count = value;
      perPage = +value;
      this.setState(
        {
          count,
          perPage,
          pageMeta: { ...pageMeta, per_page: +perPage },
        },
        () => {
          if (isActive) {
            this.Listofactiveservice();
          } else if (isInactive) {
            this.Listofinactiveservice();
          } else {
            this.Listofvoucher();
          }
        }
      );
    }
  };

  handlePageClick = (e) => {
    let { isActive, isInactive, isAll } = this.state;
    const selectedPage = e.page;
    const offset = selectedPage * this.state.perPage;
    this.setState(
      {
        current_page: selectedPage,
        offset: offset,
        pageMeta: { ...this.state.pageMeta, current_page: selectedPage },
      },
      () => {
        if (isActive) {
          this.Listofactivevoucher();
        } else if (isInactive) {
          this.Listofinactivevoucher();
        } else if (isAll) {
          this.Listofvoucher();
        }else {
          this.handleFilterChange();
        }
      }
    );
  };

  /* Data Filter from the list */
  handleFilterChange = () => {
    let {
      voucherList,
      pageCount,
      filterdata,
      search,
      seachdata,
      perPage,
      current_page,
      pageMeta,
    } = this.state;
    filterdata = voucherList.filter((item) => {
      return Object.values(item)
        .join("")
        .toLowerCase()
        .includes(search.toLowerCase());
    });
    this.setState({ filterdata });
    seachdata = filterdata.slice(
      (current_page - 1) * perPage,
      (current_page - 1) * perPage + perPage
    );
    pageCount = Math.ceil(filterdata.length / this.state.perPage);
    this.setState({
      seachdata,
      pageCount,
      pageMeta: { ...pageMeta, total_pages: pageCount },
    });
  };


  //************Searching option **********//
  filterByName = ({ target: { value, name } }) => {
    let { 
      voucherList, 
      filterdata, 
      search, 
      seachdata, 
      pageCount,
      activeButton,
      inactiveButton,
      pageMeta,
      current_page,
      perPage
    } = this.state;
    if (name === "search") {
      search = value;
      this.setState({ search });
    }
    if (search.length === 0) {
      this.Listofvoucher();
    }
    if (search !== "") {
      filterdata = voucherList.filter((item) => {
        const isActive = item.itmStatus ? "Yes" : "No";
        const lowerCaseSearch = search.toLowerCase();
        const lowerCaseCode = item.itmCode ? item.itmCode.toLowerCase() : "";
        const lowerCaseDesc = item.itmDesc ? item.itmDesc.toLowerCase() : "";
        const lowerCaseBrand = item.brand ? item.brand.toLowerCase() : "";
        const lowerCaseActive = isActive ? isActive.toLowerCase() : "";
        if (activeButton && item.itmStatus === false) {
          return false;
        }
        if (inactiveButton && item.itmStatus === true) {
          return false;
        }
        return (
          lowerCaseCode.includes(lowerCaseSearch) ||
          lowerCaseDesc.includes(lowerCaseSearch) ||
          lowerCaseBrand.includes(lowerCaseSearch) ||
          lowerCaseActive.includes(lowerCaseSearch)
        );
      });
    } else {
      filterdata = voucherList;
    }
    this.setState({ filterdata });
    if (filterdata.length < 10) {
      seachdata = filterdata;
    } else {
      seachdata = filterdata.slice(
        (current_page - 1) * perPage,
        (current_page - 1) * perPage + perPage
      );
    }
    pageCount = Math.ceil(filterdata.length / this.state.perPage);
    this.setState({ 
      seachdata, 
      pageCount,
      isActive: false,
      isInactive: false,
      isAll: false,
      pageMeta: { ...pageMeta, total_pages: pageCount },
    });
  };

  render() {
    let {
      headerDetails,
      is_loading,
      option,
      count,
      List,
      pageMeta,
      search,
      isActive,
      isAll,
      isInactive,
      filterdata,
    } = this.state;
    let { t } = this.props;
    return (
      <>
        <div className="container-fluid department-container bg-white">
          <div className="row">
            <div className={"itemmaster-container col-12"}>
              <div className="align-items-center">
                <div className="col-12">
                  <h4 className="label-head text-center text-md-left text-lg-left mt-3 mb-0">
                    {t("Range")}
                  </h4>
                </div>
                <div className="col-12">
                  <p className="label-title text-center text-md-left text-lg-left mt-3">
                    {t("Voucher")}
                  </p>
                </div>
                <div className="mt-3 col-12 d-md-flex justify-content-md-between m-0 p-0">
                  <div className="d-md-flex col-12 col-md-4">
                    <div className="p-1">
                      <NormalButtonBackend
                        mainbg={true}
                        label={"All"}
                        isActive={isAll}
                        onClick={this.Listofvoucher}
                      />
                    </div>
                    <div className="p-1">
                      <NormalButtonBackend
                        mainbg={true}
                        label={"Active"}
                        isActive={isActive}
                        onClick={this.Listofactivevoucher}
                      />
                    </div>
                    <div className="p-1">
                      <NormalButtonBackend
                        mainbg={true}
                        label={"Inactive"}
                        isActive={isInactive}
                        onClick={this.Listofinactivevoucher}
                      />
                    </div>
                  </div>
                  <div className="p-1 col-12 col-md-4">
                    <InputSearch
                      type="search"
                      placeholder={t("Search")}
                      onChange={this.filterByName}
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-center justify-content-md-start col-12 mt-3">
                  <p className="mt-2 mr-1">{t("Show")}</p>
                  <div className="p-1">
                    <NormalSelect
                      options={option}
                      value={count}
                      onChange={this.temp}
                      name="count"
                    />
                  </div>
                  <p className="mt-2 ml-1">{t("Entries")}</p>
                </div>
              </div>
              <div className="tab-table-content">
                {search.length > 0 ? (
                  <div className="tab-table-content">
                    <div className="py-4">
                      <div className="table-container">
                        <NormalTable
                          headerDetails={headerDetails}
                          pageMeta={pageMeta}
                          queryHandler={(event) => this.handlePageClick(event)}
                        >
                          {is_loading ? (
                            <tr>
                              <td colSpan="7">
                                <div class="d-flex mt-5 align-items-center justify-content-center">
                                  <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ) : filterdata.length > 0 ? (
                            filterdata.map(
                              (
                                { itmCode, itmDesc, brand, itmStatus },
                                index
                              ) => {
                                return (
                                  <tr key={index}>
                                    <td>
                                      <div
                                        className="text-left text-primary"
                                        onClick={() =>
                                          this.props.history.push(
                                            `/admin/backend/VoucherId/${itmCode}`
                                          )
                                        }
                                      >
                                        {itmCode}
                                      </div>
                                    </td>
                                    <td>
                                      <div className="text-left">{itmDesc}</div>
                                    </td>
                                    <td>
                                      <div className="text-left">{brand}</div>
                                    </td>
                                    <td>
                                      <div className="text-left">
                                        {itmStatus == true ? "Yes" : "No"}
                                      </div>
                                    </td>
                                  </tr>
                                );
                              }
                            )
                          ) : null}
                        </NormalTable>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="py-4">
                    <div className="table-container">
                      <NormalTable
                        headerDetails={headerDetails}
                        pageMeta={pageMeta}
                        queryHandler={(event) => this.handlePageClick(event)}
                      >
                        {is_loading ? (
                          <tr>
                            <td colSpan="7">
                              <div class="d-flex mt-5 align-items-center justify-content-center">
                                <div class="spinner-border" role="status">
                                  <span class="sr-only">Loading...</span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : List.length > 0 ? (
                          List.map(
                            ({ itmCode, itmDesc, brand, itmStatus }, index) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    <div
                                      className="text-left text-primary"
                                      onClick={() =>
                                        this.props.history.push(
                                          `/admin/backend/VoucherId/${itmCode}`
                                        )
                                      }
                                    >
                                      {itmCode}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="text-left">{itmDesc}</div>
                                  </td>
                                  <td>
                                    <div className="text-left">{brand}</div>
                                  </td>
                                  <td>
                                    <div className="text-left">
                                      {itmStatus == true ? "Yes" : "No"}
                                    </div>
                                  </td>
                                </tr>
                              );
                            }
                          )
                        ) : null}
                      </NormalTable>
                    </div>
                  </div>
                )}
              </div>
              <div
                className="icon"
                onClick={() =>
                  this.props.history.push(
                    `/admin/backend/itemclassification/range/voucher`
                  )
                }
              >
                +
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      rangelists,
    },
    dispatch
  );
};

export const Itemclassvoucher = withTranslation()(
  connect(null, mapDispatchToProps)(ItemclassvoucherClass)
);
